import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageLayout } from "../../../../../Layout/PageLayout";
import { useHistory } from "react-router-dom";
import { GingaIcon } from "@stonelog/stonelog-ginga-icons";
import { hubsSelector } from "../../../../../features/senninha/hubsSlice";
import { getProviderInformation, providerInformationsSelector, setResetPostProviderInformationStatus } from "../../../../../features/senninha/GestaoEquipe/providerInformationsSlice";
import { getEmployeesInfosLogistic } from "../../../../../features/senninha/employeesInfosLogistic";
import Breadcrumbs from "../../../../../components/Breadcumbs";
import PageHeader from "@components/PageHeader";
import InfosProviderEditing from "./InfosProviderEditing";
import { capitalizeFirstWord } from "../../../../../utils/formatter";
import { toCapitalizeFirstLetterOfEachWord } from "../../../../../utils/common";
import { notification } from "antd";

import * as S from "./styles";


const TeamManagement = () => {

    const [api, contextHolder] = notification.useNotification();
    const [openProviderEditDrawer, setOpenProviderEditDrawer] = useState(false);

    const [isFromMap, setIsFromMap] = useState(false);

    const dispatch = useDispatch();
    const history = useHistory();

    const {
        postProviderInformationStatus,
        getProviderInformationData,
        postProviderInformationDataError,
    } = useSelector(providerInformationsSelector);

    const {
        selectedDistrictInfos,
        selectedRegionInfos,
        selectedHubInfos
    } = useSelector(hubsSelector);

    const messageMultipleReasons = (message) => {
        api.info({
            type: "success",
            message,
            placement: "bottomLeft",
            className: "notification-ginga-design",
            closeIcon: <S.CloseButton>Fechar</S.CloseButton>,
        });
    };

    const toggle = (message) => {
        messageMultipleReasons(message);
    };

    useEffect(() => {
        if (history.location.state?.openProviderEditDrawer) {
            setOpenProviderEditDrawer(true);
            setIsFromMap(true);

            history.replace({
                pathname: history.location.pathname,
                state: { ...history.location.state, openProviderEditDrawer: false }
            });
        }
    }, [history.location.state]);

    useEffect(() => {
        if (postProviderInformationStatus === 'fulfilled') {
            dispatch(getProviderInformation({ polo: selectedHubInfos.children }));
            setOpenProviderEditDrawer(false);
            toggle("Alterações salvas.");

            if (isFromMap) {
                setTimeout(() => {
                    history.push({
                        pathname: "/senninha",
                        state: {
                            region: selectedRegionInfos.children,
                            district: selectedDistrictInfos.children,
                            pole: selectedHubInfos.children,
                        },
                    });
                }, 1000);
            }
        } else if (postProviderInformationStatus === "rejected") {
            toggle(`Erro ao salvar a alterações: ${postProviderInformationDataError?.message}.`);
        }
    }, [postProviderInformationStatus]);

    useEffect(() => {
        dispatch(getProviderInformation({ polo: selectedHubInfos.children }));
        dispatch(getEmployeesInfosLogistic());
        dispatch(setResetPostProviderInformationStatus());
    }, []);

    const optionsTeamButton = [
        {
            icon: "location",
            title: "Controle de Roteirização",
            subtitle: "Gerencie colaboradores para roteirização e acompanhe os registros diários feitos no Green App.",
            onClick: () => console.log("Não implementado"),
            suffixIcon: <GingaIcon name='chevron-right' color="rgba(1, 30, 50, 0.24)" size={24} />,
            disabled: true
        },
        {
            icon: "avatar-delete",
            title: "Justificativa de Improdutividade",
            subtitle: "Acompanhe a produtividade dos colaboradores e justifique absenteísmos diariamente.",
            onClick: () => {
                history.push({
                    pathname: "/lmp/senninha/gestao-de-equipe/justificativa-de-improdutividade",
                });
            },
            suffixIcon: <GingaIcon name='chevron-right' color="rgba(1, 30, 50, 0.24)" size={24} />,
            disabled: false
        },
        {
            icon: "shop",
            title: `${capitalizeFirstWord(selectedHubInfos?.children) || selectedHubInfos?.children}`,
            subtitle: `${getProviderInformationData?.endereco}, ${getProviderInformationData?.numero_endereco} 
            ${('- ' + toCapitalizeFirstLetterOfEachWord(getProviderInformationData?.complemento))}, ${getProviderInformationData?.bairro} - ${getProviderInformationData?.uf},
            ${getProviderInformationData?.cep}`,
            onClick: () => setOpenProviderEditDrawer(true),
            suffixIcon:
                <S.EditPoloContainer>
                    <GingaIcon name='edit' color="rgba(48, 55, 66, 1)" size={20} />
                </S.EditPoloContainer>,
            disabled: false
        },
    ];

    return (
        <PageLayout titlePage={" |  Senninha"} showHamburguerIcon={true}>
            {contextHolder}
            <S.AllPageTeam>
                <Breadcrumbs
                    onPathClickConfig={{
                        pathSnippet: 'senninha',
                        data: {
                            region: selectedRegionInfos.children,
                            district: selectedDistrictInfos.children,
                            pole: selectedHubInfos.children,
                        }
                    }}
                />
                <PageHeader
                    title="Gestão de Equipe"
                    onGoBack={() => {
                        history.push({
                            pathname: "/senninha",
                            state: {
                                region: selectedRegionInfos.children,
                                district: selectedDistrictInfos.children,
                                pole: selectedHubInfos.children,
                            },
                        });
                    }}
                />
                <S.ContainerPageTeam>
                    <InfosProviderEditing
                        openProviderEditDrawer={openProviderEditDrawer}
                        setOpenProviderEditDrawer={setOpenProviderEditDrawer}
                    />

                    {optionsTeamButton.map((optionsButton, idx) => (
                        <S.ContentButtonTeam
                            key={idx}
                            onClick={optionsButton.onClick}
                            disabled={optionsButton.disabled}
                        >
                            <S.LeftContentButtonTeam>
                                <S.IconButtonTeam>
                                    <GingaIcon name={optionsButton.icon} color="rgba(0, 113, 63, 0.87)" size={24} />
                                </S.IconButtonTeam>
                                <S.TextButtonTeam>
                                    <span>{optionsButton.title}</span>
                                    <p>{optionsButton.subtitle}</p>
                                </S.TextButtonTeam>
                            </S.LeftContentButtonTeam>
                            <S.RightContentButtonTeam>
                                {optionsButton.suffixIcon}
                            </S.RightContentButtonTeam>
                        </S.ContentButtonTeam>
                    ))}
                </S.ContainerPageTeam>
            </S.AllPageTeam>
        </PageLayout>
    );
};

export default TeamManagement;